export default {
  deTopic: {
    derivative: {
      t0: "您通过哪种方式了解衍生品？",
      t1: "了解",
      t2: "不了解",
      t3: "无法开户，请先了解衍生品知识。",
      t4: "可选择以下任意一项",
      t5: "1、已接受有关的培训或课程（可多选）",
      t6: "监管机构",
      t7: "交易所",
      t8: "大专院校",
      t9: "进修学院",
      t10: "金融机构",
      t11: "2、于经济公司或银行、基金或资产管理公司、监管机构 或交易所等金融机构有关的工作经验（可多选）",
      t12: "受监管持牌人士",
      t13: "管理层",
      t14: "与衍生工具相关活动",
      t15: "3、于过去三年内进行了五次或以上有关任何衍生产品之交易(不论是否在交易所买卖)",
      t16: "是",
      t17: "否",
      t18: "请上传所选项的相关凭证",
      t19: "提示：请根据实际情况提供相关凭证，有助于我们给您提供更好的服务和体验",
      t20: "客户在六个月内的财务状况是否有重大更改? (例如: 破产或清盘等)",
      t21: "是",
      t22: "否",
      t23: "请提供日期及详情",
      t24: "请输入...",
      t25: "客户是否该账户之最终实益拥有人？",
      t26: "本公司不接受此类型用户开户",
      t27: "是",
      t28: "否",
      t29: "申请原因",
      t30: "请输入...",
      t31: "* 号必填",
      t32: "客户确认及承诺",
      t33: "倘签署本部份，客户即声明、同意及确认：",
      t34: "本人之前在高盈证券开立的户口资料己更改。附上更改账户资料表格。",
      t35: "本人声明之前在高盈证券开立的户口资料没有任何更改，亦同意高盈证券的条款及条件均与上述现有账户相同，包括授权操作账户之安排。",
      t36: "1.在不抵触当地适用法律的情况下，本人同意高盈证券可向国内及海外的监管机构或税务机构提供本人的资料以确立本人于任何司法管辖区的税务责任。",
      t37: "2.因应国内或海外的监管机构或税务机构需要，本人准许并同意高盈证券可按适用的法律、法规和指令在本人账户中扣留相关所须的金额款项。",
      t38: "本人谨此明确地、无条件地及不可取消地放弃本人因高盈证券因应国内或海外的监管机构或税务机构需要而在本人账户中扣留相关所须的金额款项所发生的损失的索赔权利，及本人须赔偿予高盈证券因此而引起的法律责任。",
      t39: "3. 本人保证所提供的任何资料如有变更，需于三十日内通知高盈证券。",
      t40: "声明",
      t41: "1. 倘若之前在高盈证券开立的户口资料没有任何更改，本人同意将原于高盈证券之现有账户之资料用作开设额外账户之用。",
      t42: "2. 倘若之前在高盈证券开立的户口资料己更改, 本人同意在高盈证券的要求下，本人将提供己更改资料的相关证明文件予高盈证券作更改现有账户资料及开设额外账户之用。",
      t43: "3. 本人证实已收取阅读及明白 证券/ 期货交易账户条款及条件(条款及条件)包括有关隐私政策及客户协议。",
      t44: "4. 高盈证券有权在任何时间以书面通知更改条款及条件，除非高盈证券收到本人终止账户通知，否则表示本人接受该更改条款及条件。",
      t45: "5. 本人现声明及确认已获得并完全了解按照本人选择的语言之风险披露声明，本人已获邀阅读及签署风险披露声明，如有疑问可征求独立意见。",
      t46: "6. 本人/吾等明白高盈证券有最终接纳开立额外账户与否之权利。",
      t47: "本人/吾等同意输入登录密码确认签名同时用于现有客户加开额外交易账户申请表、开户申请表、衍生产品基本知识课程、W-8BEN表格、风险承受能力问卷、风险披露声明、客户常设授权、税务居民数据、FATCA、投资者识别及场外证券汇报制度之客户资料收集声明和其他适用文件。",
      t48: "本人/吾等同意输入登录密码确认签名同时用于现有客户加开额外交易账户申请表、账户资料更改表格、开户申请表、衍生产品基本知识课程、W-8BEN表格、风险承受能力问卷、风险披露声明、客户常设授权、税务居民数据、FATCA、投资者识别及场外证券汇报制度之客户资料收集声明和其他适用文件。",
      t49: "我知道了",
      t50: "开始处理",
      t51: "如需开通额外交易账号，请联系客服"

    }
  },
  treemap:{
    t0: "港股",
    t1: "美股",
    t2: "行情延迟至少15分钟",
    t3: "热力图"
  }
};
